import React from 'react'
import Modal from 'components/Luxkit/Modal/Modal'
import Group from 'components/utils/Group'
import BookingProtectionComparison from './BookingProtectionComparison/BookingProtectionComparison'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { bookingProtectionCancellationReasons } from 'lib/checkout/bookingProtection/utils'
import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'

const CancellationReasonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: ${rem(8)};

  ${mediaQueryUp.largeDesktop} {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: ${rem(8)};
  }
`

interface Props {
  cancellationType: 'free' | 'flexible' | undefined;
  cancelUntilFullRefundDate: moment.Moment | undefined;
  cancelAfterNonRefundableDate?: moment.Moment | undefined;
  bookingProtectionLastEligibleRefundDate?: moment.Moment;
}

function BookingProtectionModal(props: Props) {
  const { cancellationType, cancelUntilFullRefundDate, cancelAfterNonRefundableDate, bookingProtectionLastEligibleRefundDate } = props

  return <Modal
    title="Cancellation Protection policy"
    size="L"
  >
    <Group direction="vertical" gap={20}>
      <BodyText variant="medium">
        Things don't always work out, so enjoy peace of mind knowing that the following cancellation options are available to you.
      </BodyText>
      <CancellationReasonsContainer>
        {bookingProtectionCancellationReasons.map((reason: string, index: number) => (
          <Group direction="horizontal" key={index} verticalAlign="center">
            <LineCheckIcon colour="highlight-secondary-normal" />
            <BodyText variant="medium">
              {reason}
            </BodyText>
          </Group>
        ))}
      </CancellationReasonsContainer>
      <BookingProtectionComparison
        cancellationType={cancellationType}
        cancelUntilFullRefundDate={cancelUntilFullRefundDate}
        cancelAfterNonRefundableDate={cancelAfterNonRefundableDate}
        bookingProtectionLastEligibleRefundDate={bookingProtectionLastEligibleRefundDate}
      />
    </Group>
  </Modal>
}

export default BookingProtectionModal
